/** @jsx jsx */
import PropTypes from "prop-types"
import { jsx, Box } from "theme-ui"

const Tile = ({ bg, color, className, children }) => (
  <Box
    sx={{
      bg,
      color,
      borderRadius: "default",
      boxShadow: "0 0.25rem 0.5rem rgba(0,0,0,0.3)",
      p: 4,
      "&>h1,h2,h3,h4,h5,h6": {
        color,
      },
    }}
    className={className}
  >
    {children}
  </Box>
)

Tile.defaultProps = {
  bg: "background",
  color: "text",
}

Tile.propTypes = {
  bg: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.any,
}

export default Tile
